import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-980d7be2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "code-textarea-switch",
  "data-testid": "code-switch"
}

import SvgIcon from '@/popup/components/shared/SvgIcon.vue'

type Props = {
  showQrCodeText: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CodeTextareaSwitch',
  props: {
    showQrCodeText: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SvgIcon, {
      name: _ctx.showQrCodeText ? 'camera' : 'clipboard',
      color: "var(--neutral-20)"
    }, null, 8 /* PROPS */, ["name"])
  ]))
}
}

})